export interface NavItem {
  label: string;
  href: string;
}
export const NAV_ITEMS: NavItem[] = [{
  label: 'Mercados',
  href: '#mercados'
}, {
  label: 'Plataforma',
  href: '#plataforma'
}, {
  label: 'Ventajas',
  href: '#ventajas'
}, {
  label: 'Cómo funciona',
  href: '#como-funciona'
}, {
  label: 'FAQ',
  href: '#faq'
}];
export interface MarketCard {
  key: string;
  title: string;
  description: string;
}
export const MARKETS: MarketCard[] = [{
  key: 'forex',
  title: 'FOREX',
  description: 'Explora oportunidades en el mercado de divisas.'
}, {
  key: 'indices',
  title: 'ÍNDICES',
  description: 'Accede a instrumentos vinculados a diferentes mercados globales.'
}, {
  key: 'metales',
  title: 'METALES',
  description: 'Conoce alternativas como los metales dentro de los mercados financieros.'
}, {
  key: 'cripto',
  title: 'CRIPTO',
  description: 'Explora instrumentos relacionados con activos digitales.'
}];
export interface Benefit {
  number: string;
  title: string;
  description: string;
}
export const BENEFITS: Benefit[] = [{
  number: '01',
  title: 'EXPERIENCIA DIGITAL',
  description: 'Explora una experiencia moderna desde dispositivos compatibles.'
}, {
  number: '02',
  title: 'MÚLTIPLES MERCADOS',
  description: 'Conoce diferentes categorías de instrumentos financieros.'
}, {
  number: '03',
  title: 'INTERFAZ MODERNA',
  description: 'Visualiza la información de mercado mediante una interfaz intuitiva.'
}, {
  number: '04',
  title: 'FLEXIBILIDAD',
  description: 'Accede a tu entorno de trading según las opciones disponibles.'
}, {
  number: '05',
  title: 'INFORMACIÓN DE MERCADO',
  description: 'Consulta información relevante para tus decisiones.'
}, {
  number: '06',
  title: 'EXPERIENCIA PROFESIONAL',
  description: 'Una experiencia pensada para traders que buscan herramientas digitales.'
}];
export interface Step {
  number: string;
  title: string;
  description: string;
}
export const STEPS: Step[] = [{
  number: '01',
  title: 'CREA TU CUENTA',
  description: "Regístrate en minutos y comienza a explorar. Prueba la cuenta demo sin necesidad de realizar un depósito."
}, {
  number: '02',
  title: 'COMPLETA TU REGISTRO',
  description: "Introduce la información solicitada por la plataforma y deposita fondos a tu cuenta con cripto o con tarjeta."
}, {
  number: '03',
  title: 'EXPLORA LA PLATAFORMA',
  description: "Accede a los mercados de Forex, metales, índices y criptomonedas desde TradeLocker y comienza a operar."
}];
export interface FaqItem {
  question: string;
  answer: string;
}
export const FAQS: FaqItem[] = [{
  question: '¿Qué es Elyon Markets?',
  answer: 'Elyon Markets es un bróker que ofrece acceso a una plataforma digital de trading sobre distintas categorías de instrumentos financieros. Esta página es una landing independiente de afiliación: para conocer el detalle de sus servicios, consulta las condiciones vigentes directamente en la plataforma.'
}, {
  question: '¿Cómo puedo registrarme?',
  answer: 'Pulsa cualquiera de los botones «Abrir cuenta» de esta página. Se abrirá el formulario de registro de la plataforma, donde completarás el proceso paso a paso.'
}, {
  question: '¿Qué necesito para abrir una cuenta?',
  answer: 'El registro se realiza online y la propia plataforma indica la información y documentación que solicita durante el proceso. Consulta las condiciones vigentes directamente en la plataforma.'
}, {
  question: '¿Qué mercados están disponibles?',
  answer: 'La plataforma agrupa categorías como forex, índices, metales y criptomonedas. El listado concreto de instrumentos puede variar: consulta las condiciones vigentes directamente en la plataforma.'
}, {
  question: '¿Puedo acceder desde mi móvil?',
  answer: 'El acceso se realiza desde dispositivos compatibles. Para conocer las opciones de acceso disponibles, consulta las condiciones vigentes directamente en la plataforma.'
}, {
  question: '¿Cuál es el depósito mínimo?',
  answer: 'No publicamos importes en esta página independiente. Consulta las condiciones vigentes directamente en la plataforma.'
}, {
  question: '¿El trading tiene riesgos?',
  answer: 'Sí. El trading implica riesgos y puede no ser adecuado para todos los inversores. Existe la posibilidad de perder el capital invertido, por lo que no deberías operar con dinero que no puedas permitirte perder.'
}, {
  question: '¿Cómo funciona el proceso de registro?',
  answer: 'Accedes al formulario desde esta página, introduces la información solicitada y, una vez completado el proceso según los requisitos de la plataforma, puedes explorar su entorno de trading. Consulta las condiciones vigentes directamente en la plataforma.'
}];
export const INSTRUMENT_LABELS = ['EUR/USD', 'XAU/USD', 'US 100', 'GBP/JPY', 'BTC/USD', 'US 30'];